import InvoiceJournal from '@/invoice/InvoiceJournal.vue'
import InvoiceView from '@/invoice/InvoiceView.vue'
import InvoiceCreatorView from '@/invoice/InvoiceCreator/InvoiceCreatorView.vue'
import { PanelContent } from '@tritt/multipanel'

export const INVOICE_JOURNAL: PanelContent = {
    componentName: 'InvoiceJournal',
    path: '/reports/invoice-journal',
    component: InvoiceJournal,
    meta: { requiresOrg: true }
}

export const INVOICE_VIEW: PanelContent = {
    componentName: 'InvoiceView',
    path: '/invoice/:invoiceUuid',
    component: InvoiceView,
    meta: { requiresOrg: true }
}

export const INVOICE_CREATOR: PanelContent = {
    componentName: 'InvoiceCreator',
    path: '/invoice/create/v2',
    component: InvoiceCreatorView,
    meta: { requiresOrg: true, isSingleton: true }
}